import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { BandeauMiseAJour } from './miseajour/BandeauMiseAJour.js';
import { demarrerMiseAJour } from './miseajour/enregistrement.js';
import { createUserManager, loadRuntimeConfig } from './runtime.js';
import { appliquerThemeMemorise } from './shell/theme.js';
import './design/tokens.css';
import './design/base.css';
import './design/patterns.css';
import './shell/shell.css';

const root = document.getElementById('root');
if (root === null) throw new Error('Élément racine absent');

// Service worker et nouvelles versions (src/miseajour) : avant tout le reste.
demarrerMiseAJour();

// Ancien écran public de la veille de crise (`/crise/affichage`, retiré le 2026-11-01,
// chantier H) : la veille ne s'affiche plus sans connexion. Un téléviseur resté sur cette
// adresse est renvoyé vers le client d'écran, qui affiche son QR code d'appairage ; une fois
// appairé en mode « Crise », il montre la veille et le Live sous son jeton (révocable).
if (window.location.pathname.replace(/\/+$/, '') === '/crise/affichage') {
  window.location.replace('/ecran');
} else {
  // Thème choisi dans Mon compte : appliqué dès le démarrage, sur toutes les pages.
  appliquerThemeMemorise();
  const config = await loadRuntimeConfig();
  createRoot(root).render(
    <StrictMode>
      <App config={config} users={createUserManager(config)} />
      <BandeauMiseAJour />
    </StrictMode>,
  );
}
